<template>
  <div class="login">
    <div class="loginBox">
      <img src="../assets/images/zh-CN.png" class="logo">
      <h2>{{loginLan.priceEngine}}</h2>
      <label>
        <img src="../assets/images/ren.png">
        <input type="text" :placeholder="loginLan.loginTxt" v-model="formValue.name" @keyup.enter="loginFn">
      </label>
      <label>
        <img src="../assets/images/suo.png">
        <input type="password" :placeholder="loginLan.passwordTxt" v-model="formValue.password" @keyup.enter="loginFn">
      </label>
      <button @click="loginFn">{{loginLan.login}}</button>
      <div class="language">
        <span>{{loginLan.language}}</span>
        <select name="language" id="language" ref="language" v-model="lang" @change="changeLanguage(lang)">
          <option value="cn"> 简体中文 </option>
          <option value="hk"> 繁體中文 </option>
          <option value="en"> English </option>
        </select>
      </div>
    </div>
    <Modal v-model="modalShow" class="modal-content-j" size="sm" :footer="false" :header="false" :backdrop="true">
      <div style="font-size:16px; text-align:center; "><i class="glyphicon glyphicon-warning-sign color-red"></i>{{errTips}}</div>
    </Modal>
  </div>
</template>

<script>
import { URL_ROLELOGIN } from 'api/api.js'
import { Modal } from 'uiv'

export default {
  mixins: [require("@/common/mixin/base.js").base({ loginLan: "login" })],
  components: {
    Modal
  },
  data() {
    return {
      formValue: { // admin password
        name: "",
        password: "",
      },
      modalShow: false,
      lang: localStorage.language ? localStorage.language : 'cn',
      errTips: '',
    }
  },
  computed: {},
  methods: {
    loginFn() {
      this.$http.post(URL_ROLELOGIN,{username: this.formValue.name, password: this.formValue.password})
      .then(res => {
        if(res.data.code === 200 && res.data.msg === 'OK'){
          this.SAVEUSER(JSON.stringify({name: res.data.data.login, isSuper: res.data.data.isSuper}))
          this.$router.push({path: '/mainView'})
        }else {
          this.modalShow = true
          if(res.data.msg == 'disabled user' ) this.errTips = this.loginLan.tips.disabledUser
          else this.errTips = this.loginLan.tips.loginErr
        }
      })
      .catch(e => {
        alert(e)
      })
    },
    changeLanguage(language) {
      this.SAVELANGUAGE(language)
      localStorage.language = language
    },
  },
  watch: {},
  created() {
    sessionStorage.curSideBar = ''
  }
}
</script>

<style lang="scss" scoped>
  .login{
    .glyphicon{
      margin-right: 10px;
    }
    .loginBox{
      display: flex;
      flex-direction: column;
      align-items: center;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      background: white;
      z-index: 2;
      width: 300px;
      padding: 10px;
      border: 1px solid #ddd;
      .logo {
        width: 139px;
        height: 58px;
        margin-top: 50px;
        margin-bottom: 20px;
      }
      h2 {
        font-size: 16px;
        line-height: 25px;
        margin-bottom: 30px;
        margin-top: 0;
        color: black;
        font-weight: normal;
      }
      label {
        width: 100%;
        height: 40px;
        position: relative;
        margin-bottom: 20px;
        display: block;
        img {
          width: 25px;
          height: 25px;
          position: absolute;
          top: 7.5px;
          left: 5px;
        }
        input {
          width: 100%;
          height: 42px;
          display: block;
          padding: 0;
          border: 1px solid #BABABA;
          padding-left: 35px;
          box-sizing: border-box;
        }
        .palceholder{
          position: absolute;
          left:35px;
          top:10px;
          color:#757575;
        }
      }
      button {
        background: #2196F3;
        width: 100%;
        height: 30px;
        padding: 7px 12px;
        box-sizing: border-box;
        font-size: 13px;
        border-radius: 3px;
        text-align: center;
        line-height: 17px;
        border: none;
        color: #fff;
        margin-bottom: 30px;
        cursor: pointer;
      }
      .language {
        font-size: 14px;
        margin-bottom: 5px;
      }
    }
  }
</style>






// WEBPACK FOOTER //
// src/views/login.vue